import { MenuBookOutlinedIcon, NoRowsOverlay } from '@shared/components';

export default function ExamCenterCourseListNoRowsOverlay() {
  return <NoRowsOverlay icon={MenuBookOutlinedIcon} title='ยังไม่มีหลักสูตรที่เปิดสอบ' />;
}
